module.exports = __webpack_public_path__ + "static/media/subICloud1.8813ac79.png";